import React from 'react';
import { MDBCard,MDBContainer,MDBBtn,MDBView, MDBCardBody, MDBCardImage, MDBCardTitle, MDBCardText, MDBRow, MDBCol, MDBIcon } from 'mdbreact';

const Header = () => {
  return (<div>
        <section className="my-5">
          <MDBContainer>
            <MDBRow>
              <MDBCol>
              <h1 className='font-weight-bold mb-0 pt-md-5'>
                  VisakhaDairy
                </h1>
                <hr className='hr-light my-4 ' />
                <h4 className='subtext-header mt-2 mb-4'>
                  

Sri Vijaya Visakha Milk Producers Company Limited (Visakha Dairy) was established in the year 1973 under Co-operative Societies Act and commissioned dairy plant at Akkireddipalem, Visakhapatnam with 50,000 LPD handling capacity in the year 1977.
                </h4>
                <MDBBtn outline rounded color='red'>
                  <MDBIcon icon='home' /> Visit us
                </MDBBtn>
              </MDBCol>
              <MDBCol md="4" className="p-5">
            
              <MDBView hover zoom className=" justify" style={{padding:"30px"}}>
             <center>
             <img
                src="http://www.visakhadairy.com/images/logo.png"
                className="img-fluid m-3"
                alt=""
                
              />
             
             </center>
            </MDBView>
               
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </section>
     
    <MDBContainer className="my-5" >
   
    <MDBRow  >
      <MDBCol md="12" className="" >

        <MDBCard reverse className="card-image" style={{
                background:"skyblue", //fec321
                // backgroundImage:
                // "url(http://dairy-farm.ancorathemes.com/wp-content/uploads/2016/09/yellow_bg.jpg?id=334)",
                  backgroundPosition: "center",
                  backgroundRepeat:" no-repeat",
                  backgroundSize: "cover",

              }} >     
          
          <MDBCardImage cascade   />
          <MDBCardBody cascade className="text-center">
            <MDBCardTitle>Visakha Dairy</MDBCardTitle>
            <p className="black-text">Sri Vijaya Visakha Milk Producers Company Limited
                 (Visakha Dairy) was established in the year 1973 under Co-operative Societies Act and commissioned dairy plant at Akkireddipalem,
                 Visakhapatnam with 50,000 LPD handling capacity in the year 1977. </p>
            <MDBCardText></MDBCardText>
           
          </MDBCardBody>
        </MDBCard>
      </MDBCol>
    </MDBRow>
    </MDBContainer>
  
  </div>
)
}

export default Header;